import React from 'react';
import { TaskSection } from 'components/common/TaskSection';
import { CommentsV2 } from 'components/common';
import { procurementServices } from '@services';
import { useFormContext } from 'react-hook-form';
import { showError } from '@utils';
import { useAssignees } from '@hooks';

const Comments = ({ index, orderId, comments = [], onGetComments }) => {
  const { assignees: agents } = useAssignees();

  const methods = useFormContext();
  const skuGroupId = methods.watch(`skuGroups.${index}.vehicleDetails.skuId`);

  const handleAddComment = async (comment) => {
    try {
      await procurementServices.addSkuGroupComment(orderId, skuGroupId, {
        comment,
      });
      await onGetComments();
    } catch (error) {
      showError(error);
    }
  };

  const handleEditComment = async (commentId, comment) => {
    try {
      await procurementServices.updateComment(commentId, { comment });
      await onGetComments();
    } catch (error) {
      showError(error);
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      await procurementServices.deleteComment(commentId);
      await onGetComments();
    } catch (error) {
      showError(error);
    }
  };

  return (
    <TaskSection title="Comments" isEmbedded>
      <CommentsV2
        comments={comments}
        onSubmit={handleAddComment}
        onEdit={handleEditComment}
        onDelete={handleDeleteComment}
        users={agents}
      />
    </TaskSection>
  );
};

export default Comments;
